/**
 * Váznost
 */
export enum Severity {
  /**
   * Odpaad
   */
  GARBAGE = 'GARBAGE',

  /**
   * Informace
   */
  INFO = 'INFO',

  /**
   * Varování
   */
  WARN = 'WARN',

  /**
   * Chyba
   */
  ERROR = 'ERROR',
}
